var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.479,
    height: 22.742,
    viewBox: "0 0 23.479 22.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160132",
    "data-name": "Group 160132",
    transform: "translate(-0.051 -0.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37788",
    "data-name": "Path 37788",
    d: "M26.59,18.987a6.6,6.6,0,1,1-6.6-6.6A6.6,6.6,0,0,1,26.59,18.987Z",
    transform: "translate(-3.561 -3.293)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x2: 11.479,
    transform: "translate(4.482 5.803)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37789",
    "data-name": "Path 37789",
    d: "M5.1,11.618h6.508a6.593,6.593,0,0,1,9.259-.783V5.893L15.7.75H1.436a.686.686,0,0,0-.686.686V20.18a.686.686,0,0,0,.686.686H4.463V12.254A.636.636,0,0,1,5.1,11.618Z",
    transform: "translate(-0.199 -0.199)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37790",
    "data-name": "Path 37790",
    d: "M11.376,19.829a6.571,6.571,0,0,1,1.574-4.275H6.443a.635.635,0,0,0-.636.635V24.8H13.64A6.582,6.582,0,0,1,11.376,19.829Z",
    transform: "translate(-1.543 -4.135)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37791",
    "data-name": "Path 37791",
    d: "M16.771,17.93h8.236l-3.121,3.228v2.119L20.009,25.2v-4Z",
    transform: "translate(-4.459 -4.766)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFilter);
export default __webpack_public_path__ + "static/media/Save-Filter.ab44fd21034fadfcc28b06cafdc095c5.svg";
export { ForwardRef as ReactComponent };